import { EDITABLE_FIELDS } from '@routes/sidebar/admin-center/___shared___/components/tables/constants.ts';
import { COMMON_FILTER_PARAMS } from '@routes/sidebar/admin-center/___shared___/constants.ts';
import type { ReferencesRaw } from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___shared___/types.ts';

import { MY_IMPORTED_LEARNINGS_COLUMN_TITLE, MY_IMPORTED_LEARNINGS_DATA_INDEX } from './constants.ts';

export const MY_IMPORTED_LEARNINGS_COLUMNS_VIEW: ReferencesRaw[] = [
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.EMPLOYEE_ID,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.EMPLOYEE_ID,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '120px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.SOURCE_SYSTEM,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.SOURCE_SYSTEM,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '110px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.SOURCE_USER_ID,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.SOURCE_USER_ID,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '110px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.TYPE,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.TYPE,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '140px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.TITLE,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.TITLE,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '260px',
        align: 'left',
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.COMPLETED_DATE,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.COMPLETED_DATE,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '120px',
        align: 'right',
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.SOURCE_RANK,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.SOURCE_RANK,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '100px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.REQUIRED,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.REQUIRED,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '100px',
        align: 'center',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.COMPLETION,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.COMPLETION,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '110px',
        align: 'right',
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.SCORE,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.SCORE,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '80px',
        align: 'right',
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.LEARNING_TIME,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.LEARNING_TIME,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '110px',
        align: 'right',
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.IMPORTED_ON,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.IMPORTED_ON,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '120px',
        align: 'right',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_IMPORTED_LEARNINGS_COLUMN_TITLE.IMPORTED_BY,
        dataIndex: MY_IMPORTED_LEARNINGS_DATA_INDEX.IMPORTED_BY,
        editable: false,
        require: false,
        sorter: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '220px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
];
